import React, {Fragment} from 'react';

import {Stack} from '@mui/material';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';

import {translations} from 'presentation/translations-new';

import {ExamsFilterByLetter} from './components/FilterByLetter';
import {SearchBarProps} from './types';

import {Filter} from 'presentation/components/Filter';
import {Drawer} from 'presentation/components/Drawer';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {CurrentLocation} from 'presentation/modules/booking/shared/ui/components/CurrentLocation';
import {UnitsFilterDrawer} from 'presentation/modules/booking/shared/ui/components/UnitsFilterDrawer';
import {useExamSearchBar} from './hooks/useExamSearchBar';

const {apply, nearestDates, filter, distance} = translations['pt-br'].commons;

export function ExamSearchBar({
	placeholder,
	readOnly,
	activeStep,
	searchDataTagId,
}: SearchBarProps) {
	const {
		openDrawerState,
		handleOpenDrawer,
		handleCloseDrawer,
		disabledSelectionDate,
		showProfessionalFilters,
		showSearchField,
		showFilterByLetter,
		handleChangeDate,
		PERIODS,
		handleConfirmShift,
		handleClearShift,
		shift,
		showFilter,
		filterIsActive,
		showDistanceDrawer,
		distanceFilterAtMaxDistance,
		handleConfirmDistance,
		handleClearDistance,
		showCurrentLocation,
		availableDates,
		currentSelectedDate,
		externalOpenDateModal,
		setExternalOpenDateModal,
		distanceLabel,
	} = useExamSearchBar({activeStep});

	return (
		<Filter.Root>
			{showSearchField || showFilter ? (
				<Stack direction={'row'} gap={1}>
					{showSearchField ? (
						<Filter.Search
							dataTagId={searchDataTagId}
							placeholder={placeholder}
							readOnly={readOnly}
						/>
					) : null}

					{showFilter ? (
						<Fragment>
							<Filter.Button
								onClick={handleOpenDrawer}
								count={filterIsActive ? distanceLabel : undefined}
								customLabel={distance}
								data-tag-id={AppointmentBookingEnum.ALTEROU_DISTANCIA_POR_FILTRO}
							/>

							<UnitsFilterDrawer
								openDrawerState={openDrawerState}
								handleOpenDrawer={handleOpenDrawer}
								handleCloseDrawer={handleCloseDrawer}
								showDistanceDrawer={showDistanceDrawer}
								distanceFilterAtMaxDistance={distanceFilterAtMaxDistance}
								handleConfirmDistance={handleConfirmDistance}
								handleClearDistance={handleClearDistance}
							/>
						</Fragment>
					) : null}
				</Stack>
			) : null}
			{showFilterByLetter ? <ExamsFilterByLetter /> : null}
			{showProfessionalFilters ? (
				<Stack flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
					<Filter.Date
						dataTagId={{
							openButton: AppointmentBookingEnum.CLICK_DATAS_MAIS_PROXIMAS,
						}}
						currentFirstDate={currentSelectedDate}
						selectFirstDate={handleChangeDate}
						customOpenModalButton={nearestDates}
						customLabelConfirmButton={apply}
						availableDates={availableDates}
						disableConfirmButton={disabledSelectionDate}
						externalOpen={externalOpenDateModal}
						onAbandonModal={() => setExternalOpenDateModal(false)}
					/>
					<Filter.Button onClick={handleOpenDrawer} count={shift ? 1 : undefined} />
					<Drawer.Root
						open={openDrawerState}
						onOpen={handleOpenDrawer}
						onClose={() => handleCloseDrawer(true)}
						width={'420px'}
						sx={{zIndex: 9000}}>
						<Drawer.Header title={filter} onClose={() => handleCloseDrawer(true)} />
						<Drawer.ContentListByCategory categoryList={[PERIODS]} />
						<Drawer.Footer
							firstButtonOnClick={handleClearShift}
							secondButtonOnClick={handleConfirmShift}
						/>
					</Drawer.Root>
				</Stack>
			) : null}
			{showCurrentLocation ? (
				<CurrentLocation
					dataTagId={AppointmentBookingEnum.CLICK_ALTERAR_LOCALIZACAO}
					flowType={FlowEnum.EXAM}
				/>
			) : null}
		</Filter.Root>
	);
}
